import { render, staticRenderFns } from "./term.vue?vue&type=template&id=d16badbe&scoped=true&"
var script = {}
import style0 from "./term.vue?vue&type=style&index=0&id=d16badbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16badbe",
  null
  
)

export default component.exports